import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-ecp-ant-ui',
  template: `
    <p>
      ecp-ant-ui works!
    </p>
  `,
  styles: []
})
export class EcpAntUiComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
